import {
  HiBookOpen,
  HiChartBar,
  HiCollection,
  HiOutlineAnnotation,
  HiOutlineDocumentText,
  HiSearchCircle,
} from "react-icons/hi";

export type ContentSubTab = "overview" | "syllables" | "words" | "lessons" | "cards" | "patterns";

interface ContentSubNavProps {
  activeTab: ContentSubTab;
  onTabChange: (tab: ContentSubTab) => void;
}

const SUBTABS = [
  { id: "overview" as ContentSubTab, label: "Overview", icon: HiChartBar },
  { id: "syllables" as ContentSubTab, label: "Syllables", icon: HiOutlineAnnotation },
  { id: "words" as ContentSubTab, label: "Words", icon: HiOutlineDocumentText },
  { id: "lessons" as ContentSubTab, label: "Lessons", icon: HiBookOpen },
  { id: "cards" as ContentSubTab, label: "Cards", icon: HiCollection },
  { id: "patterns" as ContentSubTab, label: "Patterns", icon: HiSearchCircle },
] as const;

export function ContentSubNav({ activeTab, onTabChange }: ContentSubNavProps) {
  return (
    <div className="border-b border-gray-200 dark:border-gray-800 mb-6">
      <nav className="flex flex-wrap gap-1" aria-label="Content breakdown tabs">
        {SUBTABS.map((tab) => {
          const Icon = tab.icon;
          return (
            <button
              key={tab.id}
              type="button"
              onClick={() => onTabChange(tab.id)}
              className={`
                flex items-center gap-2 px-4 py-2 text-sm font-medium rounded-t-lg transition-colors border-b-2
                ${
                  activeTab === tab.id
                    ? "bg-surface text-primary-600 dark:text-primary-400 border-primary-600 dark:border-primary-500"
                    : "text-gray-700 dark:text-secondary-200 border-transparent hover:text-primary-600 dark:hover:text-primary-400 hover:bg-gray-100 dark:hover:bg-gray-100 dark:hover:bg-gray-800"
                }
              `}
              aria-current={activeTab === tab.id ? "page" : undefined}
            >
              <Icon className="text-base" />
              {tab.label}
            </button>
          );
        })}
      </nav>
    </div>
  );
}
